import StaffQuickLogin from './StaffQuickLogin'

export * from './StaffQuickLogin'

export default StaffQuickLogin
